import { Routes } from '@angular/router';
import { AccessDeniedPageComponent } from '@sb-tools/typescript/components/error-pages/access-denied-page/access-denied-page.component';
import { InitRedirectGuard } from '@core/guards/init-redirect.guard';
import { CanActivateCommunitySettingsGuard } from '@core/guards/can-activate-community-settings.guard';
import { CanActivateSuperAdminSettingsGuard } from '@core/guards/can-activate-super-admin-settings.guard';
import { NotFoundPageComponent } from '@sb-tools/typescript/components/error-pages/not-found-page/not-found-page.component';
import { InternalServerErrorPageComponent } from '@sb-tools/typescript/components/error-pages/internal-server-error-page/internal-server-error-page.component';
import { LayoutWithLeftMenuComponent } from './layout-with-left-menu/layout-with-left-menu.component';
import { AuthenticatedUserGuard } from '@core/guards/authenticated-user.guard';
import { FacebookRedirectGuard } from '@core/guards/facebook-redirect.guard';
import { InstagramRedirectGuard } from '@core/guards/instagram-redirect.guard';
import { GOOGLE_INSTALLATION_PATH, YOUTUBE_INSTALLATION_PATH } from '@core/constants/installation-paths';
import { TrustpilotRedirectGuard } from '@core/guards/trustpilot-redirect.guard';
import { GoogleRedirectGuard } from '@core/guards/google-redirect.guard';
import { YoutubeRedirectGuard } from '@core/guards/youtube-redirect.guard';
import { TiktokRedirectGuard } from '@core/guards/tiktok-redirect.guard';
import { MicrosoftDynamicsRedirectGuard } from '@core/guards/microsoft-dynamics-redirect.guard';
import { RedirectGuard } from '@core/guards/redirect.guard';

const childrenRoutes: Routes = [
    {
        path: '403',
        component: AccessDeniedPageComponent,
    },
    {
        path: '',
        pathMatch: 'full',
        canActivate: [InitRedirectGuard],
        children: [],
    },
    {
        path: 'user',
        loadChildren: () => import('./user-settings/user-settings-routes').then((m) => m.USER_SETTINGS_ROUTES),
        data: {
            preload: true,
            breadcrumb: {
                skip: true,
            },
        },
    },
    {
        path: 'community',
        loadChildren: () =>
            import('./community-settings/community-settings-routes').then((m) => m.COMMUNITY_SETTINGS_ROUTES),
        canActivate: [CanActivateCommunitySettingsGuard],
        data: {
            preload: true,
            breadcrumb: {
                skip: true,
            },
        },
    },
    {
        path: 'super-admin',
        loadChildren: () =>
            import('./super-admin-settings/super-admin-settings-routes').then((m) => m.SUPER_ADMIN_SETTINGS_ROUTES),
        canActivate: [CanActivateSuperAdminSettingsGuard],
        data: {
            preload: true,
            breadcrumb: {
                skip: true,
            },
        },
    },
];

export const APP_ROUTES: Routes = [
    {
        path: '404',
        component: NotFoundPageComponent,
    },
    {
        path: '403',
        component: AccessDeniedPageComponent,
    },
    {
        path: '500',
        component: InternalServerErrorPageComponent,
    },
    {
        path: '',
        component: LayoutWithLeftMenuComponent,
        canActivate: [AuthenticatedUserGuard],
        children: [
            {
                path: 'facebookInstallation',
                canActivate: [FacebookRedirectGuard],
                children: [],
            },
            {
                path: 'instagramInstallation',
                canActivate: [InstagramRedirectGuard],
                children: [],
            },
            {
                path: 'trustpilotInstallation',
                canActivate: [TrustpilotRedirectGuard],
                children: [],
            },
            {
                path: GOOGLE_INSTALLATION_PATH,
                canActivate: [GoogleRedirectGuard],
                children: [],
            },
            {
                path: YOUTUBE_INSTALLATION_PATH,
                canActivate: [YoutubeRedirectGuard],
                children: [],
            },
            {
                path: 'tiktokinstallation',
                canActivate: [TiktokRedirectGuard],
                children: [],
            },
            {
                path: 'microsoftDynamicsSb',
                canActivate: [MicrosoftDynamicsRedirectGuard],
                children: [],
            },
            {
                path: ':communityName',
                children: childrenRoutes,
                data: { breadcrumb: { skip: true } },
            },
            {
                path: '**',
                canActivate: [RedirectGuard],
                children: [],
            },
        ],
    },
];
